var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.64568 2.33984L0.942653 10.0515C0.903856 10.0904 0.876029 10.1396 0.86265 10.1924L0.00883909 13.6229C-0.0165799 13.7263 0.0136553 13.8361 0.0888421 13.9114C0.145834 13.9684 0.223429 14 0.302897 14C0.327246 14 0.352129 13.9971 0.376211 13.9909L3.80323 13.1363C3.85674 13.1229 3.90517 13.095 3.94397 13.0562L11.6478 5.34502L8.64568 2.33984Z",
    fill: "#223D51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.556 1.28852L12.6984 0.430086C12.1256 -0.14363 11.1267 -0.143094 10.5541 0.430086L9.50366 1.48163L12.5055 4.48654L13.556 3.435C13.8423 3.14841 13.9999 2.76727 13.9999 2.36176C13.9999 1.95625 13.8423 1.57511 13.556 1.28852Z",
    fill: "#223D51"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9421 11.7109H7.28868C6.70438 11.7109 6.23071 12.1851 6.23071 12.77V12.9409C6.23071 13.5258 6.70438 13.9999 7.28868 13.9999H12.9421C13.5264 13.9999 14.0001 13.5258 14.0001 12.9409V12.77C14.0001 12.1851 13.5264 11.7109 12.9421 11.7109Z",
    fill: "#223D51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditar);
export default __webpack_public_path__ + "static/media/editar.1b71d9b31feeefa73e4b26359bc9a799.svg";
export { ForwardRef as ReactComponent };